import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { Titles } from '../../../layouts/Titles'
import i from '../../../translations/i'
import { ProductTable } from '../../../components/product_table/ProductTable'
import { ProductTableController } from '../../../components/product_table/product_table.controller'

// Все товары: поиск по названию, ID, CRM и артикулу, фильтры по категории, складу и статусу
export const ProductList = observer(() => {
    const [table] = useState(() => new ProductTableController({ syncUrl: true }))

    return (
        <>
            <Titles
                title={i.t('nav:products')}
                breadcrumb={[
                    { title: i.t('nav:products') }
                ]}
                buttons={[
                    { title: i.t('categories:createProduct'), href: `/shop/catalog/product/0`, type: `primary` }
                ]}
            />

            <ProductTable table={table} />
        </>
    )
})
